import {SIDEBAR_CONTACT_BUTTON_SIZE, SIDEBAR_SINGLE_CARD_HEIGHT, SIDEBAR_SINGLE_CARD_SECURITY_THRESHOLD} from '../const';

const calculateNumberOfSidebarItemsDisplayable = containerHeight => {
  const number = Math.floor((containerHeight - SIDEBAR_SINGLE_CARD_SECURITY_THRESHOLD) / SIDEBAR_SINGLE_CARD_HEIGHT);
  return number;
};

const calculateNeededSpaceForSidebarCards = (numberOfItems = 0) => {
  const totalHeight = numberOfItems * SIDEBAR_SINGLE_CARD_HEIGHT;
  const paddingVertical = 24;
  return totalHeight + SIDEBAR_SINGLE_CARD_SECURITY_THRESHOLD + paddingVertical;
};

const canAllSidebarCardsFitOnScreen = (containerHeight, totalNumberOfItems) => {
  const SEPARATOR_HEIGHT = 30;
  const itemsHeight = calculateNeededSpaceForSidebarCards(totalNumberOfItems);
  const totalHeight = SEPARATOR_HEIGHT + itemsHeight + SIDEBAR_CONTACT_BUTTON_SIZE;

  return containerHeight > totalHeight;
};

export {calculateNumberOfSidebarItemsDisplayable, calculateNeededSpaceForSidebarCards, canAllSidebarCardsFitOnScreen};
